import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions, ResponseContentType } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable";
import { AppCommonService } from "../appcommon.service";
import { AuthService } from "../auth.service";
import { GlobalService } from "../global.service";
import { Router } from "@angular/router";
import { ApiEndPoints } from "../api.endpoints";
import { forEach } from "@angular/router/src/utils/collection";
import { Invoice, Certificate, Ebilling, LedgerLines, Statement, InvoiceDocumentModel, InvoicesModel, StatementModel, StatementDocumentModel, CertificateModel, CertificatesContainerModel, CertificateDocumentModel, LedgerLineModel, EbillingModel, LedgerLineModelNew } from "./invoicing";
import { LoaderService } from "../LoaderService";
import { debug } from "util";

@Injectable()
export class InvoicingService extends GlobalService {
    constructor(
        private http: Http,
        private cookieService: CookieService,
        private appCommonService: AppCommonService,
        private authService: AuthService,
        public loaderService: LoaderService,
        private router: Router
    ) {
        super(http, router);
        this.authServiceRef = this.authService;
    }

    getInvoices(model: InvoicesModel): Observable<Invoice[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetInvoices;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    getInvoicesByAccountId(id: string): Observable<Invoice[]> {
        let headers = this.authService.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        const url = ApiEndPoints.InvoicesEndPoint.replace('{accountId}', id);
        return this.http.get(url, options)
            .map(this.extractData)
            // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
            .catch(this.handleError);
    }

    getInvoiceById(accountId: string, id: string): Observable<Invoice> {
        let headers = this.authService.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        const url = ApiEndPoints.InvoiceByIdEndPoint.replace('{accountId}', accountId).replace('{invoiceId}', id);
        return this.http.get(url, options)
            .map(this.extractData)
            // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
            .catch(this.handleError);
    }

    getInvoiceDocument(model: InvoiceDocumentModel) {
        let body = JSON.stringify(model);
        //debugger
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DownloadInvoiceEndPoint;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/x-www-form-urlencoded;'
        //});
        return this.http
            .post(callURL, body, {
                responseType: ResponseContentType.Blob, headers: this.authService.GetHeaderDocument()
            })
            .map(res => {
                const contentDisposition = res.headers.get('content-disposition') || '';
                const matches = /filename=([^;]+)/ig.exec(contentDisposition);
                const fileName = (matches[1] || 'untitled').trim();
                return {
                    filename: fileName,
                    data: res.blob()
                };
            })
            .subscribe(res => {
                if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(res.data, res.filename);
                    this.loaderService.display(false);
                }
                else {
                    var url = window.URL.createObjectURL(res.data);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = url;
                    a.download = res.filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove(); // remove the element
                    this.loaderService.display(false);
                }
            }, error => {
                this.loaderService.display(false);
                alert('download error:' + JSON.stringify(error));
                //console.log('download error:', JSON.stringify(error));
            }, () => {
                //console.log('Completed file download.')
            });
    }

    getStatements(model: StatementModel): Observable<Statement[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetStatements;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    getStatementDocument(model: StatementDocumentModel) {
        let body = JSON.stringify(model);
        //debugger;
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DownloadStatementEndPoint;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/x-www-form-urlencoded;'
        //});
        return this.http
            .post(callURL, body, {
                responseType: ResponseContentType.Blob, headers: this.authService.GetHeaderDocument()
            })
            .map(res => {
                const contentDisposition = res.headers.get('content-disposition') || '';
                const matches = /filename=([^;]+)/ig.exec(contentDisposition);
                const fileName = (matches[1] || 'untitled').trim();
                return {
                    filename: fileName,
                    data: res.blob()
                };
            })
            .subscribe(res => {
                if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(res.data, res.filename);
                    this.loaderService.display(false);
                } else {
                    var url = window.URL.createObjectURL(res.data);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = url;
                    a.download = res.filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove(); // remove the element
                    this.loaderService.display(false);
                }
            }, error => {
                this.loaderService.display(false);
                alert('download error:' + JSON.stringify(error));
                //console.log('download error:', JSON.stringify(error));
            }, () => {
                //console.log('Completed file download.')
            });
    }

    getStatementsByAccountId(id: string): Observable<Statement[]> {
        let headers = this.authService.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        const url = ApiEndPoints.StatementsEndPoint.replace('{accountId}', id);
        return this.http.get(url, options)
            .map(this.extractData)
            // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
            .catch(this.handleError);
    }

    getStatementById(accountId: string, id: string): Observable<Statement> {
        let headers = this.authService.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        const url = ApiEndPoints.StatementByIdEndPoint.replace('{accountId}', accountId).replace('{statementId}', id);
        return this.http.get(url, options)
            .map(this.extractData)
            // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
            .catch(this.handleError);
    }

    getCertificates(model: CertificateModel): Observable<Certificate[]> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetCertificates;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    requestCertificateDocuments(model: CertificatesContainerModel): Observable<boolean> {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.RequestCertificateEndPoint;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    getCertificateDocument(model: CertificateDocumentModel) {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DownloadCertificateEndPoint;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/x-www-form-urlencoded;'
        //});
        return this.http
            .post(callURL, body, {
                responseType: ResponseContentType.Blob, headers: this.authService.GetHeaderDocument()
            })
            .map(res => {
                const contentDisposition = res.headers.get('content-disposition') || '';
                const matches = /filename=([^;]+)/ig.exec(contentDisposition);
                const fileName = (matches[1] || 'untitled').trim();
                return {
                    filename: fileName,
                    data: res.blob()
                };
            })
            .subscribe(res => {
                if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(res.data, res.filename);
                    this.loaderService.display(false);
                }
                else {
                    var url = window.URL.createObjectURL(res.data);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = url;
                    a.download = res.filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove(); // remove the element
                    this.loaderService.display(false);
                }

            }, error => {
                this.loaderService.display(false);
                alert('download error:' + JSON.stringify(error));
                //console.log('download error:', JSON.stringify(error));
            }, () => {
                //console.log('Completed file download.')
            });
    }

    getCertificatesByAccountId(id: string): Observable<Certificate[]> {
        let headers = this.authService.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        const url = ApiEndPoints.CertificatesEndPoint.replace('{accountId}', id);
        return this.http.get(url, options)
            .map(this.extractData)
            // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
            .catch(this.handleError);
    }

    getCertificateById(accountId: string, id: string): Observable<Certificate> {
        let headers = this.authService.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        const url = ApiEndPoints.CertificateByIdEndPoint.replace('{accountId}', accountId).replace('{certificateId}', id);
        return this.http.get(url, options)
            .map(this.extractData)
            // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
            .catch(this.handleError);
    }

    getEbillingByAccountId(id: string): Observable<Ebilling> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.EbillingEndPoint.replace('{accountId}', id);
            return this.http.get(url, options)
                .map(this.extractData)
                // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
                .catch(this.handleError);
        }
        else {
            let token = this.authService.getToken();
            let model = new EbillingModel();
            model.EndPointURL = ApiEndPoints.EbillingEndPoint;
            model.AccountId = id;
            model.Token = token.access_token;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.EbillingEndPointServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    saveEbilling(ebilling: Ebilling, id: string): Observable<Ebilling> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.EbillingEndPoint.replace('{accountId}', id);
            return this.http.put(url, ebilling, options)
                // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
                .catch(this.handleError);
        }
        else {
            let token = this.authService.getToken();
            let model = new EbillingModel();
            model.EndPointURL = ApiEndPoints.EbillingEndPoint;
            model.Token = token.access_token;
            model.Ebilling = ebilling;
            model.AccountId = id;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.EbillingEndPointSaveServer;
            return this.http.put(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    getLedgerLinesByAccountId(id: string): Observable<LedgerLines> {
        if (ApiEndPoints.UseDirectEndPoint) {
            let headers = this.authService.GetAuthHeader();
            let options = new RequestOptions({ headers: headers });
            const url = ApiEndPoints.LedgerLinesEndPoint.replace('{accountId}', id);
            return this.http.get(url, options)
                .map(this.extractData)
                // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
                .catch(this.handleError);
        } else {
            let token = this.authService.getToken();
            let model = new LedgerLineModel();
            model.EndPointURL = ApiEndPoints.LedgerLinesEndPoint;
            model.AccountId = id;
            model.Token = token.access_token;
            let body = JSON.stringify(model);
            //let headers: Headers = new Headers({
            //  'Content-Type': 'application/json; charset=utf-8'
            //});
            let options = new RequestOptions({ headers: this.authService.GetHeader() });
            let callURL = ApiEndPoints.BaseURL + ApiEndPoints.LedgerLinesEndPointServer;
            return this.http.post(callURL, body, options)
                .map((response: Response) => <any>response.json())
                .catch(this.handleError);
        }
    }

    getLedgerLinesByAccountIdNew(accountNumbers: string[]): Observable<LedgerLines> {

        let token = this.authService.getToken();
        let model = new LedgerLineModelNew();
        //model.EndPointURL = ApiEndPoints.LedgerLinesEndPoint;
        model.Accounts = accountNumbers;
        model.Token = token.access_token;
        let body = JSON.stringify(model);
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/json; charset=utf-8'
        //});
      
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.LedgerLinesNewEndPointServer;
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);

    }


    getHistoricalInvoices(model: InvoicesModel): Observable<Invoice[]> {

        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetHistoricalInvoices;
        
        let options = new RequestOptions({ headers: this.authService.GetHeader() });
        return this.http.post(callURL, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }


    getHistoricalInvoiceDocument(model: InvoiceDocumentModel) {
        let body = JSON.stringify(model);
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DownloadHistoricalInvoiceEndPoint;
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/x-www-form-urlencoded;'
        //});
        return this.http
            .post(callURL, body, {
                responseType: ResponseContentType.Blob, headers: this.authService.GetHeaderDocument()
            })
            .map(res => {
                const contentDisposition = res.headers.get('content-disposition') || '';
                const matches = /filename=([^;]+)/ig.exec(contentDisposition);
                const fileName = (matches[1] || 'untitled').trim();
                return {
                    filename: fileName,
                    data: res.blob()
                };
            })
            .subscribe(res => {
                if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(res.data, res.filename);
                    this.loaderService.display(false);
                }
                else {
                    var url = window.URL.createObjectURL(res.data);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = url;
                    a.download = res.filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove(); // remove the element
                    this.loaderService.display(false);
                }
            }, error => {
                this.loaderService.display(false);
                alert('download error:' + JSON.stringify(error));
                //console.log('download error:', JSON.stringify(error));
            }, () => {
                //console.log('Completed file download.')
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicing.service.ts